import { useState } from "react";
import { auth } from "../store/authStore";

export const useUploadBlob = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<string>();

  const upload = (blob: Blob, onSuccess: (data: string) => void) => {
    setLoading(true);
    // Create a FormData object to send the file
    const formData = new FormData();
    const filename = blob instanceof File ? blob.name : "upload";
    formData.append("file", blob, filename);

    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001/v1';
    const token = auth.getToken();

    // Send the form data to your endpoint using fetch (with auth so the URL is persisted)
    fetch(`${baseUrl}/media/temporary`, {
      method: "POST",
      body: formData,
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    })
      .then((response) => response.json())
      .then(async (data) => {
        try {
          const url = data?.url ?? data;
          if (url) {
            setData(url);
            onSuccess(url);
          }
          setLoading(false);
        } catch {
          setLoading(false);
          return;
        }
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        setLoading(false);
      });
  };

  return { upload, loading, data };
};
